import { useState, useEffect } from "react";
import { ArrowLeft, BookOpen, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { API } from '../config/api';
import MarkdownDoc from "../components/MarkdownDoc";
import axios from "axios";

export default function SOPPage() {
  const navigate = useNavigate();
  const [sopContent, setSopContent] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/sop/content`)
      .then(res => setSopContent(res.data.content || ""))
      .catch(() => setSopContent("Failed to load SOP content."))
      .finally(() => setLoading(false));
  }, []);

  const filteredContent = search
    ? sopContent.split("\n").filter(line =>
        line.toLowerCase().includes(search.toLowerCase())
      ).join("\n")
    : sopContent;

  return (
    <div className="min-h-screen bg-navy" data-testid="sop-page">
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <Button variant="ghost" onClick={() => navigate(-1)} className="text-txt-muted hover:text-white hover:bg-navy-hover" data-testid="sop-back-btn">
              <ArrowLeft className="w-4 h-4 mr-1" /> Back
            </Button>
            <div className="flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-teal" />
              <h1 className="text-xl font-semibold text-white">Bonsai Law — Standard Operating Procedures</h1>
            </div>
          </div>
          <span className="text-xs text-teal font-mono bg-teal/20 px-2 py-1 rounded">v32.0</span>
        </div>

        <div className="relative mb-6">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-txt-muted" />
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search SOP..."
            className="w-full pl-10 pr-4 py-2.5 rounded-md border border-navy-border text-sm text-white placeholder-[#7a86a8] bg-navy-hover focus:outline-none focus:ring-2 focus:ring-teal/30 focus:border-teal"
            data-testid="sop-search"
          />
        </div>

        {loading ? (
          <div className="text-center py-20 text-txt-muted">Loading SOP...</div>
        ) : (
          <MarkdownDoc
            markdown={filteredContent}
            testId="sop-content"
            className="rounded-md border border-navy-border bg-navy shadow-lg p-8"
          />
        )}
      </div>

    </div>
  );
}
